module.exports = __webpack_public_path__ + "img/caracteristicas-captores.87a13aa1.jpg";